import axios from "axios"
import Paginations from "components/Common/Pagination"
import { API_URL } from "components/Common/Utils"
import IsLoading from "components/Shared/IsLoading"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Button, Table } from "reactstrap"
import { getMatchedCandidatesList } from "store/actions/interviewsAction"
import { getMatchedTheoreticalCandidates } from "store/actions/theoreticalTrainingAction"
import { showAlert } from "store/reducers/alertReducer"

const MatchedCandidates = ({ values }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    isMatching,
    theoreticalMatchedCandidates,
    perPage,
    totalPages1,
    currentPage1,
    totalCount1,
  } = useSelector(state => state.TheoreticalTraining)
  const [isExporting, setIsExporting] = useState(false)

  const pageNumber = 1

  useEffect(() => {
    const getAllData = page => {
      const { is_saudi, group_classification, training_jobs } = values
      const updatedTrainingJobIds =
        training_jobs?.map(item => {
          return { ...item, job_title_id: item?.job_title_id.value }
        }) || []

      const data = {
        limit: perPage,
        page_number: page || pageNumber,
        order_by: 1,
        filters: {
          is_saudi,
          training_jobs: updatedTrainingJobIds,
          // employee_experience: group_classification,
        },
      }

      dispatch(getMatchedTheoreticalCandidates(data))
    }

    getAllData()
  }, [])

  const onPageChange = page => {
    getAllData(page)
  }

  const handleExport = async () => {
    const {
      city_ids,
      specialization_id,
      gender,
      nationality_id,
      education_qualification_id,
      employee_experience,
      employee_experience_as_per_document,
      national_ids,
    } = values
    const updatedCitiesId = city_ids?.map(item => item.value) || []

    const nationalIdArray = [
      ...new Set(
        national_ids
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "") // Remove empty strings
      ),
    ]

    try {
      setIsExporting(true)
      const authUserString = localStorage.getItem("authUser")
      const authUser = authUserString ? JSON.parse(authUserString) : null
      const token = authUser?.token

      const payload = {
        export_type: "search_application",
        filters: {
          city_ids: updatedCitiesId,
          specialization_id,
          gender,
          nationality_id,
          is_saudi: null,
          education_qualification_id,
          employee_experience,
          employee_experience_as_per_document,
          national_ids: nationalIdArray,
        },
      }

      const response = await axios.post(
        `${API_URL}/api/v1/admin/export/by-type`,
        payload,
        {
          headers: {
            Authorization: token, // Attach token in headers
          },
          responseType: "blob", // Important for file downloads
        }
      )

      const contentType = response.headers["content-type"]

      if (contentType === "application/json") {
        return dispatch(
          showAlert({
            text: t("Export initiated, you will be notified once done."),
            type: "success",
          })
        )
      }

      // Create a URL for the downloaded file
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "export.xlsx") // Set filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url) // Clean up memory
    } catch (error) {
      console.error("Export failed:", error.response?.data || error.message)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <div>
      {isMatching ? (
        <IsLoading />
      ) : (
        <div className="table-responsive" style={{ maxHeight: "90vh" }}>
          <div className="d-flex justify-content-end mb-4">
            {/* {theoreticalMatchedCandidates?.length > 0 && (
              <Button
                color="primary"
                className="px-2"
                onClick={handleExport}
                disabled={isExporting}
              >
                {t("Download XLSX")}
              </Button>
            )} */}
          </div>
          {theoreticalMatchedCandidates?.length === 0 ? (
            <p className="text-center my-5 fs-4 font-bold">
              {t("No matching data found")}
            </p>
          ) : (
            <>
              <Table className="table mb-0">
                <thead className="table-light full_th">
                  <tr>
                    <th>{t("S. No.")}</th>
                    <th>{t("National Id")}</th>
                    <th>{t("Name")}</th>
                    {/* <th>{t("Email")}</th> */}
                    <th>{t("Phone Number")}</th>
                    <th>{t("Date of Birth")}</th>
                    <th>{t("Gender")}</th>
                    <th>{t("Nationality")}</th>
                    <th>{t("City")}</th>
                    <th>{t("Education Qualification")}</th>
                    <th>{t("Specialization")}</th>
                    <th>{t("Submitted Experience")}</th>
                    <th>{t("Assigned Job")}</th>
                  </tr>
                </thead>
                <tbody>
                  {theoreticalMatchedCandidates?.map((item, index) => (
                    <tr key={index}>
                      <th scope="row">
                        {(currentPage1 - 1) * perPage + index + 1}
                      </th>
                      <td>{item?.national_id}</td>
                      <td>{item?.full_name}</td>
                      {/* <td>{item?.email}</td> */}
                      <td>{item?.phone}</td>
                      <td>{item?.dob}</td>
                      <td className="text-capitalize">{item?.gender}</td>
                      <td>{item?.nationality_name}</td>
                      <td>{item?.city_name}</td>
                      <td>{item?.education_qualification_name}</td>
                      <td>{item?.specialization_name}</td>
                      <td>{item?.submit_experience === 1 ? "Yes" : "No"}</td>
                      <td className="fit_content">{item?.assign_job_title}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {!isMatching && theoreticalMatchedCandidates.length > 0 && (
                <Paginations
                  currentPage={currentPage1}
                  totalPages={totalPages1}
                  totalCount={totalCount1}
                  onPageChange={onPageChange}
                />
              )}
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default MatchedCandidates
